module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo3-8f6722e43a1b21ff5fa912aae173e51f.jpg";